var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[(!_vm.isReady && !_vm.error)?[_c('Loader')]:_c('Wrapp',{attrs:{"networkId":_vm.networkId,"account":_vm.account,"web3":_vm.$web3.library}},[_c('router-view')],1),_c('modals-container'),_c('notifications')],2)}
var staticRenderFns = []

export { render, staticRenderFns }